require('normalize.css/normalize.css')
require('../css/global.css')
require('../css/common.css')
require('./page.css')

document.addEventListener('DOMContentLoaded', () => {
});
